import React from 'react';
import { SmProgressBar } from '@smiles/smiles-react-design-system';

type TProps = {
  value: number;
  steps: 4;
  className?: string;
};

export function ProgressBar({ className, steps, value }: TProps) {
  return (
    <div className={className} data-testid="progressbar">
      <SmProgressBar steps={steps} value={value} />
    </div>
  );
}
